<template>
  <footer id="vm-cola-footer-cart" class="vm-cola-footer-cart" :style="customStyles">
    <div class="vm-cola-footer-cart__content">
      <!-- <p class="title">Keranjang belanjamu: <span>Maks. 4 produk</span></p> -->
      <!-- <p class="title">Keranjang belanjamu: <span>Maks. 4 produk</span></p> -->

      <div class="calculation">
        <div class="calculation__count">
          <img src="/static/img/icons/icon-shop-bg-pink.svg" />
        </div>
        <div class="calculation__total">
          <span>Total {{ total_price | currencyRp }} <br /> </span>
          <span class="product-count">{{ cart_qty_total }} Produk</span>
          <!-- <span>{{ cart_qty_total }}</span> -->
        </div>
      </div>

      <div class="action">
        <div class="action__reset" :class="{ disabled: cart_qty_total <= 0 }" @click="$emit('reset', cart_qty_total)">
          Ulangi Pesanan
        </div>
        <div
          v-if="!cartShowed || cart_qty_total <= 0"
          class="action__show-cart"
          :class="{ disabled: cart_qty_total <= 0 }"
          @click="$emit('show-cart', cart_qty_total)"
        >
          Bayar Sekarang
        </div>
        <div v-else class="action__show-cart" @click="$emit('checkout')">Bayar Sekarang</div>
      </div>
    </div>
    <!-- <div class="vm-cola-footer-cart__banner">
      <div class="banner-area">
        <img class="qr-code-sociolla" src="/static/img/icons/qr-code-sociolla.svg" />
        <img class="sociolla-apps" src="/static/img/icons/sociolla-apps.svg" />
      </div>
    </div> -->
  </footer>
</template>
<script>
export default {
  name: 'FooterCart',
  props: {
    cartShowed: {
      type: Boolean,
      default: false,
    },
    totalPrice: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    user() {
      return this.$store.state.QRcode.user;
    },
    customStyles() {
      return {
        '--top-var': this.user && this.$route.name === 'vmColaOrder' ? '320px' : '240px',
      };
    },
    cart_qty_total() {
      return this.$store.state.vmCola.cart_qty;
    },
    point_applied() {
      return this.$store.state.vmCola.point_applied || 0;
    },
    product_list() {
      return this.$store.state.vmCola.product_list;
    },
    total_price() {
      if (this.$route.name === 'vmColaOrder') {
        return this.totalPrice;
      }

      const selectedProducts = this.product_list.filter((p) => p.quantities > 0);

      try {
        if (selectedProducts && selectedProducts.length) {
          let result = 0;
          const data = selectedProducts;

          for (let i = 0; i < data.length; i++) {
            const price = data[i]?.combination?.price_after_discount || data[i].min_price_after_discount || 0;
            result += Number(price * data[i].quantities);
          }

          if (this.point_applied && this.point_applied > 0) {
            result -= this.point_applied;
          }

          return result;
        } else {
          return 0;
        }
      } catch (error) {
        console.log(error);
        return 0;
      }
    },

    current_page() {
      return this.$route.name;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/sass/mixin-revamp';

.vm-cola-footer-cart {
  height: 150px;
  width: 100%;
  position: fixed;
  z-index: 23;
  flex-wrap: wrap;
  top: var(--top-var);
  left: 0;
  border-radius: 0 0 23px 23px;
  padding: 0 35px;

  img {
    border-radius: 0 0 22px 22px;
    width: 100%;
  }

  &__content {
    display: flex;
    flex-grow: 1;
    background-color: #fedfe2;
    padding: 30px;
    border-radius: 20px;

    .title {
      font: 28px $lato_bold;
      line-height: 33.6px;
      margin-bottom: 25px;

      span {
        font: 22px $lato_regular;
        font-weight: 600;
        line-height: 26.4px;
        color: #eb395f;
      }
    }

    .calculation {
      display: flex;
      position: relative;
      gap: 15px;

      &__count {
        width: 122px;
        height: 72px;
        padding: 8px 24px;
        border-radius: 50px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        gap: 5px;

        span {
          font: 40px $lato-regular;
          font-weight: 700;
          line-height: 55.6px;
          text-align: center;
        }

        img {
          width: 45px;
          height: 64px;
        }
      }

      &__total {
        font: 31px $lato_regular;
        font-weight: 800;
        width: 300px;
        //line-height: 60px;
      }

      //margin-bottom: 30px;
    }

    .action {
      display: flex;
      flex-direction: row;
      padding-left: 10px;
      gap: 15px;

      &__reset,
      &__show-cart,
      &__checkout {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 62px;
        width: 240px;
        border-radius: 39px;
        text-align: center;
        font-size: 24px;
        font-size: 28px $lato_regular;
        font-weight: bold;
      }

      &__reset,
      &__show-cart {
        font-family: $lato-bold;
        &.disabled {
          background-color: #d8d8d8;
          color: #fff;
          border-color: #c0b0b8;
        }
      }

      &__show-cart,
      &__checkout {
        background-color: #da2a52;
        color: #fff;
      }

      &__reset,
      &__checkout {
        background-color: #fff;
        color: #000;
      }
    }
  }

  .product-count {
    font-size: 20px;
  }

  &__banner {
    width: 419px;
    border-radius: 0px 23px 0 0;
    background-color: #ffd5ea;

    .banner-area {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      border-radius: 26px 23px 0 0;
      background-color: #b12655;
      position: relative;

      .qr-code-sociolla {
        position: absolute;
        top: -45px;
        border-radius: 0;
        width: 200px;
        height: 200px;
      }

      .sociolla-apps {
        border-radius: 0;
        width: 344px;
        height: 74.3px;
        margin-top: 50px;
      }
    }
  }
}
</style>
